import React, { useState, useEffect, Fragment } from "react";
import flatstore from "flatstore";
import { useLocation } from "react-router-dom";
import { isNil, replace } from "lodash";
import parse from "html-react-parser";
import Loader from "../../components/common/Loader";
import LoadModules from "../../components/modules/LoadModules";
import Meta from "../../components/common/Meta";
import NotFound from "./404";
import { getStaticSync } from "../../utils/services";
import {
  currentLang,
  getStaticSubscriptionEmbedSlug,
  getSubscriptionPaths,
  staticSubscriptionPathIsValid,
} from "../../utils/functions";
import { useTranslation } from "react-i18next";
import SubscriptionWizard from "../Subscription/SubscriptionWizard";

function StaticSubscriptionPage({ static_data, loading, err_data }) {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [modules, setModules] = useState(null);

  const embedSlug = getStaticSubscriptionEmbedSlug(pathname);
  const pathOk = staticSubscriptionPathIsValid(pathname);
  const urlpaths = replace(pathname, "/" + currentLang() + "/", "").split("/");
  let filter;
  let is404 = false;
  if (urlpaths[1]) {
    if (urlpaths[1] === t("menu.animal") && urlpaths[2]) {
      filter = urlpaths[2];
    } else if (!pathOk) {
      is404 = true;
    }
  }

  useEffect(() => {
    if (static_data && embedSlug && static_data.slug !== embedSlug) {
      setData(null);
    }
  }, [pathname, embedSlug, static_data]);

  useEffect(() => {
    if (!is404 && embedSlug && isNil(static_data)) {
      getStaticSync(embedSlug, "static_data");
    }
    if (static_data && isNil(data) && static_data.slug === embedSlug) {
      setData(static_data);
    }
    if (static_data && static_data.modules !== null && static_data.slug === embedSlug) {
      setModules(static_data.modules);
    }
  }, [static_data, pathname, embedSlug, is404, data]);

  if (!embedSlug || !pathOk) {
    return <NotFound />;
  }

  if (loading) {
    return <Loader />;
  }

  if (is404 || err_data === "404") {
    return <NotFound />;
  }

  const normalizedPath = pathname.replace(/\/$/, "") || "/";
  const { base: subscriptionBase } = getSubscriptionPaths();
  const showPageModules =
    subscriptionBase && normalizedPath === subscriptionBase;

  return (
    <Fragment>
      {showPageModules && modules && (
        <LoadModules modules={modules} filter={filter} type="top" />
      )}
      {data && (
        <Meta
          title={data.seo_title ? data.seo_title : data.title}
          description={data.seo_description ? data.seo_description : data.body}
        />
      )}
      {showPageModules && data && data.body && (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-xxl-6 col-lg-8 my-5">
              <h1 className="heading--h1">{data.title}</h1>
              <div className="page__body">{parse(data.body)}</div>
            </div>
          </div>
        </div>
      )}
      <SubscriptionWizard />
      {showPageModules && modules && (
        <LoadModules modules={modules} filter={filter} type="bottom" />
      )}
    </Fragment>
  );
}

export default flatstore.connect(["loading", "static_data", "err_data"])(
  StaticSubscriptionPage
);
